import { useState, ReactNode } from "react";

interface VideoTooltipProps {
  children: ReactNode;
  videoSrc: string;
  type?: "video" | "iframe";
  width?: number;
  height?: number;
}

const VideoTooltip = ({
  children,
  videoSrc,
  type = "video",
  width = 320,
  height = 180,
}: VideoTooltipProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <span
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
            background: "#222",
            padding: 8,
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          {type === "video" ? (
            <video
              src={videoSrc}
              width={width}
              height={height}
              controls
              autoPlay
              muted
              style={{ display: "block" }}
            />
          ) : (
            <iframe
              src={videoSrc}
              width={width}
              height={height}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Video Tooltip"
              style={{ display: "block" }}
            />
          )}
        </div>
      )}
    </span>
  );
};

export default VideoTooltip;